import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz13 = () => {
    return (
        <div>
               <NavLink to='/category/Puzzels/Puzzel14'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel12'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">100 Prisoners with Red/Black Hats</h1>
    
    <div class="text">
        <p>100 prisoners in jail are standing in a queue facing in one direction. Each prisoner is wearing a hat of
            color either black or red. A prisoner can see hats of all prisoners in front of him in the queue, but cannot
            see his hat and hats of prisoners standing behind him.<br/>
            The jailer is going to ask color of each
            prisoner’s hat starting from the last prisoner in queue. If a prisoner tells the correct color, then is
            saved, otherwise executed. <strong>How many prisoners can be saved at most</strong> if they are allowed to
            discuss a strategy before the jailer starts asking colors of their hats.</p>
        <p>&nbsp;<br/>
            &nbsp;<br/>
            &nbsp;<br/>
            &nbsp;</p>
      <div class="containers">  <p><strong><br/>
            
            Answer:</strong><br/>
            At-most 99 prisoners can be saved and the 100th prisoner has 50-50 chances of
            being executed.<br/>
            The idea is that every prisoner counts number of red hats in front of him.</p>
        <p>100th prisoner says red if the number of red hats is even. He may or may not be saved, but he conveys enough
            information to save 99th prisoner.</p>
        <p>The 99’th prisoner decides his answer on the basis of answer of 100’th prisoner’s answer. There are following
            possibilities and 99’th prisoner can figure out color of his hat in every case.</p><br/>

        <div id="AP_G4GR_5"></div>
        
        <p>If 100’th prisoner said ‘Red’ (There must have been even number of red hats in front of him)<br/>
            a) If 99’th
            prisoner sees even number of red hats in front of him, then his color is black.<br/>
            b) If 99’th prisoner sees
            odd number of red hats in front of him, then his color is red.</p>
        <p>If 100’th prisoner said ‘Black’ (There must have been odd number of red hats in front of him)<br/>
            a) If 99’th
            prisoner sees even number of red hats in front of him, then his color is Red.<br/>
            b) If 99’th prisoner sees
            odd number of red hats in front of him, then his color is Black.</p>
        <p>The 98’th prisoner decides his answer on the basis of answer of 99’th prisoner’s answer and uses same logic.
        </p>
        <p>Similarly other prisoners from 97 to 1 are saved.</p>
        </div>
        </div>
        </article>
    </div>

        
    )
}

export default Puz13
